export default __webpack_public_path__ + "static/Asset 1@300x-4fa10468320dfef1ec48fabb938eaf14.png";